import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-bmwicon_起立",
  "use": "icon-bmwicon_起立-usage",
  "viewBox": "0 0 40 40",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 40 40\" id=\"icon-bmwicon_起立\"><circle cx=\"20\" cy=\"4.05\" r=\"3.18\" /><path d=\"M25.77,7.78H14.23A1.72,1.72,0,0,0,12.5,9.51V20.92a1,1,0,0,0,1,1h.59a1,1,0,0,0,1-1V13.81h.19v9.83h0V36.85a2.28,2.28,0,0,0,2.28,2.28h0a2.29,2.29,0,0,0,2.29-2.28V23.64h.34V36.85a2.29,2.29,0,0,0,2.29,2.28h0a2.28,2.28,0,0,0,2.28-2.28v-23h.19v7.11a1,1,0,0,0,1,1h.59a1,1,0,0,0,1-1V9.51A1.72,1.72,0,0,0,25.77,7.78Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol